import LineMetrics from './LineMetrics';
import Table from './Table';
import BarMetrics from './BarMetrics';
import TrendMetrics from './TrendMetrics';

export default { LineMetrics, Table, BarMetrics, TrendMetrics };
